import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=362b1d3a"
import script from "./counter.vue?vue&type=script&lang=ts"
export * from "./counter.vue?vue&type=script&lang=ts"
import style0 from "./counter.vue?vue&type=style&index=0&id=362b1d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_wdrzbp32twlk6ul2h2xp3hbjle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports